import get from 'lodash/get';
import { AGREEMENT } from '~/common/constants';
import { LOAN_TYPES } from '~/typings/enums/LoanType';

const FIELD_TYPES = {
  basic: ['name', 'motherName', 'document', 'birthDate'],
  address: ['zipCode', 'street', 'addressNumber', 'district', 'city', 'state'],
  bank: ['bankNumber', 'checkingAccount', 'checkingAccountDigit', 'agency', 'agencyDigit', 'pixkey'],
  registration: ['registrationNumber', 'registerNumberEmitter', 'registerNumberState', 'registerNumberDateOfIssue'],
  personal: ['maritalStatus', 'gender', 'nationality', 'cityOfBirth', 'stateOfBirth'],
};

export const FIELDS_RULES = [
  {
    rule: { loanType: LOAN_TYPES.CONSIGNED_CARD_RMC },
    fields: [...FIELD_TYPES.basic, ...FIELD_TYPES.address, ...FIELD_TYPES.registration, ...FIELD_TYPES.personal],
  },
  {
    rule: { loanType: LOAN_TYPES.BENEFIT_CARD_RCC },
    fields: [...FIELD_TYPES.basic, ...FIELD_TYPES.address, ...FIELD_TYPES.registration, ...FIELD_TYPES.personal],
  },
  {
    rule: { agreementId: AGREEMENT.CONSIGPRIV },
    fields: [...FIELD_TYPES.basic, ...FIELD_TYPES.address, ...FIELD_TYPES.bank],
  },
  {
    rule: { loanType: LOAN_TYPES.FGTS_NEW },
    fields: [...FIELD_TYPES.basic, ...FIELD_TYPES.address, ...FIELD_TYPES.bank],
  },
];

export function getConditionalFields(initialInputs: any, contract: any): string[] {
  for (const { rule, fields } of FIELDS_RULES) {
    const isMatch = Object.keys(rule).every((key) => {
      const ruleValue = rule[key];
      const inputValue = get(contract, key);

      return inputValue === ruleValue;
    });

    if (isMatch) {
      return initialInputs.filter((input) => fields.includes(input.id));
    }
  }

  return initialInputs;
}
